export class ForgotPassword {
    username: string;
    token: string;
    new: string;
}
